import { render, staticRenderFns } from "./WalletIcon.vue?vue&type=template&id=00bf37b6&scoped=true"
import script from "./WalletIcon.vue?vue&type=script&lang=ts"
export * from "./WalletIcon.vue?vue&type=script&lang=ts"
import style0 from "./WalletIcon.vue?vue&type=style&index=0&id=00bf37b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf37b6",
  null
  
)

export default component.exports